import React from 'react';
import Header from "../../components/layout/Header";
import Banner from "../../components/home/Banner";
import Footer from "../../components/layout/Footer";

const HomeDecor = () => {
    const banners = [
        "https://rukminim1.flixcart.com/fk-p-flap/1600/350/image/d34fc9b3a0429712.jpg?q=20",
        "https://rukminim1.flixcart.com/fk-p-flap/1600/350/image/3b12ea642f89f924.jpg?q=20",
        "https://rukminim1.flixcart.com/fk-p-flap/1600/350/image/62b6623631526487.jpg?q=20",
    ];

    return (
        <div style={{ backgroundColor: '#f1f2f4', minHeight: '100vh', paddingTop: '128px' }}>
            <Header />

            <div style={{ maxWidth: '1440px', margin: '0 auto', padding: '12px 16px' }}>

                {/* 1. Scrolling Hero Banner */}
                <div style={{ marginBottom: '32px', borderRadius: '24px', overflow: 'hidden', boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)' }}>
                    <Banner images={banners} height="450px" />
                </div>

                {/* 2. Room-based Navigation */}
                <div style={{ marginBottom: '40px' }}>
                    <h2 style={{ fontSize: '22px', marginBottom: '24px', textAlign: 'start', fontWeight: '800' }}>Shop by Room</h2>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '24px' }}>
                        {[
                            { room: "Living Room", img: "https://rukminim1.flixcart.com/fk-p-flap/128/128/image/d34fc9b3a0429712.jpg?q=20", count: "4.2k+ Items" },
                            { room: "Bedroom", img: "https://rukminim1.flixcart.com/fk-p-flap/128/128/image/3b12ea642f89f924.jpg?q=20", count: "3.8k+ Items" },
                            { room: "Kitchen", img: "https://rukminim1.flixcart.com/fk-p-flap/128/128/image/62b6623631526487.jpg?q=20", count: "2.1k+ Items" },
                            { room: "Office", img: "https://rukminim1.flixcart.com/fk-p-flap/128/128/image/d34fc9b3a0429712.jpg?q=20", count: "1.5k+ Items" }
                        ].map((item, i) => (
                            <div
                                key={i}
                                style={{
                                    height: '260px',
                                    borderRadius: '28px',
                                    position: 'relative',
                                    overflow: 'hidden',
                                    cursor: 'pointer',
                                    transition: '0.4s'
                                }}
                            >
                                <img src={item.img} alt={item.room} style={{ height: '100%', width: '100%', objectFit: 'cover' }} />
                                <div
                                    style={{
                                        position: 'absolute',
                                        inset: 0,
                                        background: 'linear-gradient(to top, rgba(0,0,0,0.8), transparent)',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'flex-end',
                                        padding: '24px'
                                    }}
                                >
                                    <h3 style={{ fontSize: '20px', color: 'white', fontWeight: '900', margin: 0 }}>{item.room}</h3>
                                    <p style={{ color: 'rgba(255,255,255,0.8)', fontSize: '13px', fontWeight: '700', margin: 0 }}>{item.count}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* 3. Category Carousel */}
                <div style={{ backgroundColor: 'white', padding: '32px', borderRadius: '32px', marginBottom: '48px', boxShadow: '0 1px 2px rgba(0,0,0,0.06)' }}>
                    <div style={{ display: 'flex', gap: '40px', overflowX: 'auto', paddingBottom: '16px' }} className="no-scrollbar">
                        {[
                            { name: "Wall Decor", img: "https://rukminim1.flixcart.com/fk-p-flap/128/128/image/f892a77a942a6c8e.jpg?q=20" },
                            { name: "Clocks", img: "https://rukminim1.flixcart.com/fk-p-flap/128/128/image/489f076e03328e75.jpg?q=20" },
                            { name: "Vases", img: "https://rukminim1.flixcart.com/fk-p-flap/128/128/image/091396a84c79435b.jpg?q=20" },
                            { name: "Lamps", img: "https://rukminim1.flixcart.com/fk-p-flap/128/128/image/d34fc9b3a0429712.jpg?q=20" },
                            { name: "Rugs", img: "https://rukminim1.flixcart.com/fk-p-flap/128/128/image/3b12ea642f89f924.jpg?q=20" },
                            { name: "Mirrors", img: "https://rukminim1.flixcart.com/fk-p-flap/128/128/image/62b6623631526487.jpg?q=20" }
                        ].map((cat, i) => (
                            <div key={i} style={{ minWidth: '130px', cursor: 'pointer', textAlign: 'center', transition: '0.3s', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <div style={{ width: '110px', height: '110px', backgroundColor: '#fff5f5', borderRadius: '50%', padding: '16px', border: '2px solid white', boxShadow: '0 4px 6px -1px rgba(0,0,0,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <img src={cat.img} alt={cat.name} style={{ width: '90px', height: '90px', objectFit: 'contain' }} />
                                </div>
                                <p style={{ fontWeight: '800', marginTop: '12px', fontSize: '14px', color: '#333', margin: '12px 0 0 0' }}>{cat.name}</p>
                            </div>
                        ))}
                    </div>
                </div>

                {/* 4. Top Rated Grid */}
                <div style={{ marginBottom: '80px' }}>
                    <h2 style={{ fontSize: '24px', marginBottom: '40px', fontWeight: '900', textAlign: 'start' }}>Curated for Your Home</h2>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '32px' }}>
                        {[1, 2, 3, 4].map(i => (
                            <div key={i} style={{ textAlign: 'start', cursor: 'pointer', backgroundColor: 'white', borderRadius: '28px', overflow: 'hidden', transition: '0.4s', boxShadow: '0 1px 2px rgba(0,0,0,0.06)', display: 'flex', flexDirection: 'column' }}>
                                <div style={{ height: '240px', width: '100%', overflow: 'hidden' }}>
                                    <img src="https://rukminim1.flixcart.com/image/416/416/xif0q/showpiece-figurine/v/e/u/-original-imahf4r9f9gzshge.jpeg?q=70" alt="Product" style={{ height: '100%', width: '100%', objectFit: 'cover' }} />
                                </div>
                                <div style={{ padding: '20px', display: 'flex', flexDirection: 'column', gap: '4px' }}>
                                    <span style={{ backgroundColor: '#ebf8ff', color: '#2b6cb0', padding: '2px 8px', borderRadius: '4px', fontSize: '12px', fontWeight: '600', width: 'fit-content' }}>TOP CHOICE</span>
                                    <p style={{ fontWeight: '800', fontSize: '16px', color: '#333', margin: '4px 0 0 0', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>Premium Ceramic Flower Vase</p>
                                    <p style={{ color: '#718096', fontSize: '13px', margin: 0 }}>Set of 2 | Hand-painted</p>
                                    <div style={{ marginTop: '12px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <span style={{ fontWeight: '900', fontSize: '20px' }}>₹899</span>
                                        <span style={{ color: '#388e3c', fontWeight: '800', fontSize: '14px' }}>Min. 40% Off</span>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default HomeDecor;
